import { render, staticRenderFns } from "./ServiceGlobe.vue?vue&type=template&id=112169ca&scoped=true&"
import script from "./ServiceGlobe.vue?vue&type=script&lang=js&"
export * from "./ServiceGlobe.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGlobe.vue?vue&type=style&index=0&id=112169ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112169ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
